// extracted by mini-css-extract-plugin
export default {"hidden":"hidden---ub9w_","paneTitle":"paneTitle---HuIcs"};